import axios from "axios";

/** Vue root instance, injected once by calling setRoot(this.$root) in App.vue => created. */
let _root = null;

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || "http://localhost:8080",
  timeout: 60000,
});

api.interceptors.request.use(config => {
  const teros = localStorage.getItem("teros");
  const token = JSON.parse(teros)?.token;
  if (token) {
    config.headers["X-Auth-Token"] = token;
  }
  return config;
});

/**
 * Called once in App.vue => created.
 * Injects the Vue root instance for use in withLoading().
 * @param {import('vue').default} root
 */
export function setRoot(root) {
  _root = root;
}

/**
 * Wraps an async function with the global loading overlay.
 * @param {string} key - unique id for the loading overlay
 * @param {() => Promise<any>} fn - the async func to wrap
 * @returns {Promise<any>}
 */
export async function withLoading(key, fn) {
  _root?.$emit("addLoadingProcess", key);
  try {
    return await fn();
  } finally {
    _root?.$emit("removeLoadingProcess", key);
  }
}

export default api;
